import { selectedBranchShoppingCart, setAdditionalTax } from "../shopping-cart/shopping-cart.slice";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app.store";
import { setLoading } from "states/global-value/global-value.slice";
import {  getBranchOrderPickupSettingAPI } from "./order-pickup-setting.api";
import { BranchOrderPickupSettingState, IBranchOrderPickupSettingModel } from "./order-pickup-setting.models";
import { setCookie } from "shared/plugins/list-helper";
import { AdditionalFeeItemModel } from "states/shopping-cart/shopping-cart.models";
const CURRENT_BRANCH_ID = "CurrentBranchId";
export const setBranchCookie = (value: string ) =>{
  if(value === ""){
    setCookie(CURRENT_BRANCH_ID,value,-1);
  }else{
    setCookie(CURRENT_BRANCH_ID,value,1);
  }
  
}

export const fetchBranchOrderPickupSetting = createAsyncThunk(
  "branch_order_settings/fetchSetting",
  async (_, thunkApi) => {
    try {
      const state = thunkApi.getState() as RootState;
      thunkApi.dispatch(setLoading(true));
      const res = await getBranchOrderPickupSettingAPI(state.shoppingCart.shoppingCart.branch.id);
      if(res.data.additionalTaxes.length > 0){
        thunkApi.dispatch(setAdditionalTax(res.data.additionalTaxes.map(m=> {return {
          taxName:m.taxName,
          taxRate: m.taxRate,
          feeAmount:0
        } as AdditionalFeeItemModel})));
      }
      thunkApi.dispatch(setLoading(false));
      return res.data;
    } catch (error) {
      thunkApi.dispatch(setLoading(false));
      return [];
    }
  }
);

export const branchOrderSettingSlice = createSlice({
  name: "branch_order_setting",
  initialState: {
     setting: {
      active:true,
     } as IBranchOrderPickupSettingModel,
  } as BranchOrderPickupSettingState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBranchOrderPickupSetting.fulfilled, (state, action) => {
      state.setting = action.payload as IBranchOrderPickupSettingModel;
    });
  },
});

export const selectBranchOrderPickupSetting = (state: RootState) => state.orderSetting.setting;
